<template>
  <div style="margin-bottom: 2.5rem;">
    <doe-label :name="name" :required="fieldRequired">
      {{ label }}
    </doe-label>
    <span
      v-if="prefix"
      class="absolute border-gray-800 border-r font-sans leading-snug py-2 subpixel-antialiased font-bold text-center text-black text-xl max-w-xs w-full"
    >
      {{ prefix }}
    </span>
    <v-select
      multiple
      :options="options"
      :label="optionLabel"
      v-model="selected"
      :name="name"
      :closeOnSelect="false"
      :reduce="reduce"
      v-validate="validation"
      :data-vv-as="fieldNameInErrorMessage"
      @close="validateMultiSelect"
      @option:selected="validateMultiSelect"
      @option:deselected="validateMultiSelect"
    />
    <doe-error v-if="errors.has(name)" :description="ariaErrorDescID(name)">
      {{ errors.first(name) }}
    </doe-error>
    <doe-hint :hint="hint" :description="ariaDescID(name)" />
  </div>
</template>

<script>
import DoeLabel from "@/components/field/Label";
import DoeHint from "@/components/field/Hint";
import DoeError from "@/components/field/Error";

export default {
  name: "DoeMultiSelect",
  inject: {
    $validator: "$validator"
  },
  props: {
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: [Array, Object]
    },
    label: {
      type: String,
      required: true
    },
    optionLabel: {
      type: String,
      required: true
    },
    fieldRequired: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: String
    },
    validation: {
      type: [Object, String]
    },
    hint: {
      type: [Array, String]
    },
    fieldNameInErrorMessage: {
      type: String
    },
    reduce: {
      type: Function
    }
  },
  components: {
    DoeLabel,
    DoeHint,
    DoeError
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    generateAriaDescription(fieldName) {
      if (this.errors.has(fieldName)) {
        return this.ariaErrorDescID(fieldName);
      }
      if (this.hint) {
        return this.ariaDescID(fieldName);
      }
      return false;
    },
    ariaDescID(fieldName) {
      return `${fieldName}Description`;
    },
    ariaErrorDescID(fieldName) {
      return `${fieldName}ErrorDescription`;
    },
    validateMultiSelect() {
      if(this.validation){
        this.$validator.validate(this.name);
      }
      
    }
  }
};
</script>

<style scoped>
>>> {
  --vs-controls-color: black;
  --vs-controls-size: 0.6;
  --vs-border-color: #666;

  --vs-dropdown-color: #000;
  --vs-dropdown-option-color: #000;

  --vs-selected-bg: #cecece;

  --vs-search-input-color: #000;

  --vs-font-size: 1rem;
  --vs-line-height: 2.3;
}

.v-select {
  font-family: Montserrat,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
  max-width: 500px;
}
</style>
